export default function EventInfo() {
  const info = [
    { icon: 'ri-calendar-event-fill', label: 'Data e Horário', value: '17/03/2026', sub: 'Terça-feira às 19h30' },
    { icon: 'ri-map-pin-2-fill', label: 'Local', value: 'Hotel Íbis', sub: 'Tangará da Serra – MT' },
    { icon: 'ri-group-fill', label: 'Formato', value: 'Presencial', sub: 'Evento ao vivo' },
    { icon: 'ri-alarm-warning-fill', label: 'Vagas', value: 'Limitadas', sub: 'Por horário' }
  ];

  return (
    <section className="py-14 sm:py-20 lg:py-28 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="text-center mb-10 sm:mb-14 lg:mb-16">
          <p className="text-xs font-bold text-yellow-600 tracking-widest uppercase mb-3">
            Detalhes do dia
          </p>
          <h4 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-black mb-3">
            <a href="#evento">
              Informações do <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-yellow-600">Evento</span>
            </a>
          </h4>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5 lg:gap-8">
          {info.map((item, idx) => (
            <div key={idx} className="bg-white rounded-2xl p-4 sm:p-7 lg:p-10 shadow-md text-center border border-gray-100 hover:border-yellow-500 hover:shadow-xl transition-all duration-300 cursor-pointer group">
              <div className="w-11 h-11 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-3 lg:mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className={`${item.icon} text-lg sm:text-2xl lg:text-2xl text-black`}></i>
              </div>
              <p className="text-xs font-bold text-gray-500 mb-1 lg:mb-2 uppercase tracking-wider">{item.label}</p>
              <p className="text-base sm:text-xl lg:text-2xl font-black text-black">{item.value}</p>
              <p className="text-sm sm:text-base lg:text-base font-bold text-yellow-600 mt-1">{item.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}